<template>
  <div class="addressList">
    <div class="topClass">
      <h3>收货地址</h3>
    </div>
    <section class="main">
<!--      <div class="mian-add" @click="add(1)" v-has="'WSS-5002-edit'">新增</div>-->
      <Button class="w100 mb10" type="primary" @click="add(1)" v-has="'WSS-5002-edit'">新增</Button>
      <div class="main-total borderB">
        已创建
        <i>{{ total }}</i>
        个收货地址，还可创建
        <i>{{ number }}</i>
        个
      </div>
      <div class="main-center">
        <div v-if="lists.length">
<!--          <Row-->
<!--            v-for="(item, index) in lists"-->
<!--            :key="index"-->
<!--            type="flex"-->
<!--            justify="space-between"-->
<!--          >-->
<!--            <Col span="3">-->
<!--              <span class="h3">{{ item.name }}</span>-->
<!--            </Col>-->
<!--            <Col span="4">-->
<!--              <span class="h3">{{ item.localPhone }}</span></Col-->
<!--            >-->
<!--            <Col span="8">-->
<!--              <span class="h4">{{ item.fullAddress }}</span>-->
<!--            </Col>-->
<!--            <Col span="2" class="">-->
<!--              <span v-if="item.preferred == 1" class="default">默认</span>-->
<!--            </Col>-->
<!--            <Col span="2" class="">-->
<!--              <span @click="add(item)" class="span-btn" v-has="'WSS-5002-edit'"-->
<!--                >修改</span-->
<!--              >-->
<!--            </Col>-->
<!--            <Col span="2">-->
<!--              <span-->
<!--                v-has="'WSS-5002-edit'"-->
<!--                v-if="item.preferred == 0"-->
<!--                @click="del(item.id)"-->
<!--                class="span-btn"-->
<!--                >删除</span-->
<!--              >-->
<!--            </Col>-->
<!--          </Row>-->
          <div  v-for="item in lists" :key="item.id">
            <div class="itemFlexClass borderB">
            <!--左-->
              <div class="itemLeftClass">
                <!--上-->
                <div class="itemLeftTopClass">
                  <div class="h3">{{ item.name }}</div>
                  <div class="h3 pl10 pr10">{{ item.localPhone }}</div>
                  <div v-if="item.preferred == 1" class="defauldAddress"><span>默认地址</span></div>
                </div>
                <!--下-->
                <div class="h4">{{ item.fullAddress }}</div>
              </div>
            <!--右-->
              <div class="itemRightClass">
                <span v-has="'WSS-5002-edit'" class="span-btn" @click="add(item)">修改</span>
                <span v-if="item.preferred == 0" v-has="'WSS-5002-edit'" class="span-btn" @click="del(item.id)">删除</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!lists.length" class="table-empty">暂无数据</div>
      </div>
    </section>
    <!-- 弹框 -->
    <Modal v-model="modal1" title="设置收货地址" :mask-closable="false">
      <Form
        ref="formValidate"
        :model="formValidate"
        :rules="ruleValidate"
        :label-width="100"
      >
        <FormItem label="姓名：" prop="name">
          <Input
            v-model="formValidate.name"
            placeholder="请输入收货人姓名"
          ></Input>
        </FormItem>
        <FormItem label="电话：" prop="phone">
          <Input
            v-model="formValidate.phone"
            placeholder="请输入联系电话"
          ></Input>
        </FormItem>
        <FormItem label="所在地区：" prop="cityId">
          <Select
            v-model="formValidate.provinceId"
            placeholder="请选择省份"
            style="width: 30%"
            @on-change="changeProvince"
          >
            <Option
              v-for="item in provinceArr"
              :key="item.id"
              :value="item.id"
              >{{ item.name }}</Option
            >
          </Select>
          <Select
            v-model="formValidate.cityId"
            placeholder="请选择城市"
            style="width: 30%;margin-left: 5%;"
            @on-change="changeCity"
          >
            <Option
              v-for="item in citiesArr"
              :key="item.id"
              :value="item.id"
              style="margin: 0 4px"
              >{{ item.name }}</Option
            >
          </Select>
          <Select
            v-model="formValidate.countyId"
            placeholder="请选择区县"
            style="width: 30%;margin-left: 5%;"
            @on-change="changeArea"
          >
            <Option v-for="item in countyArr" :key="item.id" :value="item.id">{{
              item.name
            }}</Option>
          </Select>
        </FormItem>
        <FormItem label="详细地址：" prop="detail">
          <Input
            v-model="formValidate.detail"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="请输入详细地址，最多100字"
          ></Input>
        </FormItem>
        <FormItem prop="preferred">
          <Checkbox v-model="formValidate.preferred" :disabled="disabled">设为默认地址</Checkbox>
        </FormItem>
      </Form>
      <div slot="footer" style="text-align: center">
        <Button type="primary" :loading="modal_loading" @click="ok('formValidate')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </Modal>
    <!-- 删除弹框 -->
    <Modal
      v-model="modal2"
      width="360"
      :mask-closable="false"
      :closable="false"
    >
      <div style="text-align: center">
        <h3 style="font-size: 18px; margin: 20px">确认删除此收货地址？</h3>
      </div>
      <div slot="footer" style="text-align: center; margin-bottom: 20px">
        <Button :loading="modal_loading" @click="btnOK">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  address,
  addressList,
  addressPost,
  Deladdress
} from '../../../api/myweb/address/address.js'
export default {
  name: 'addressList',
  components: {},
  data() {
    return {
      disabled: false,
      lists: [], // 表格
      total: '', // 已有地址个数
      number: '',
      modal1: false,
      modal2: false,
      modal_loading: false,
      formValidate: {
        name: '',
        phone: '',
        provinceId: '',
        cityId: '',
        countyId: '',
        detail: '',
        preferred: false
      },
      provinceArr: [],
      citiesArr: [],
      countyArr: [],
      id: '',
      // 地址信息
      addressList: [],
      // 验证
      ruleValidate: {
        name: [
          {
            required: true,
            message: '姓名不能为空',
            trigger: 'blur',
            max: 10
          }
        ],
        phone: [
          {
            required: true,
            message: '联系电话不能为空',
            trigger: 'blur'
          },
          {
            pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
            message: '手机号码格式不正确',
            trigger: 'blur'
          }
        ],
        cityId: [
          {
            required: true,
            message: '请选择省市区',
            trigger: 'blur'
          }
        ],
        city: [
          {
            required: true,
            message: '请选择城市',
            trigger: 'blur'
          }
        ],
        county: [
          {
            required: true,
            message: '请选择区县',
            trigger: 'blur'
          }
        ],
        detail: [
          {
            required: true,
            message: '请输入详细地址',
            trigger: 'blur'
          },
          {
            // type: 'string',
            max: 100,
            message: '最多输入100字',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted() {},
  created() {
    this.getaddress()
  },
  methods: {
    // 获取用户地址
    async getaddress() {
      const res = await address({ more: 3 })
      console.log(res,'用户地址')
      if (res.status) {
        this.lists = res.data.list
        this.total = res.data.total
        this.number = 20 - this.total
      }
    },
    // 增加/修改
    async add(val) {
      this.$refs.formValidate.resetFields()
      this.formValidate = {
        name: '',
        phone: '',
        countyId: '',
        cityId: '',
        detail: '',
        preferred: false
      }
      // 获取省市区
      const res = await addressList()
      // console.log(res)
      if (res.status) {
        this.addressList = res.data
        this.provinceArr = res.data.province
        console.log(this.provinceArr);
        // 修改
        if (val !== 1) {
          console.log(val);
          this.formValidate = JSON.parse(JSON.stringify(val))
          console.log(this.formValidate);
          this.formValidate.preferred = Boolean(this.formValidate.preferred)
          this.disabled = Boolean(this.formValidate.preferred)
          this.changeProvinces(this.formValidate.provinceId)
          this.changeCitys(this.formValidate.cityId)
          this.modal1 = true
        } else {
          // 新增
          if (this.total == 20) {
            this.$Message.warning('最多添加20个收货地址')
          } else {
            // this.formValidate = {
            //   name: '',
            //   phone: '',
            //   countyId: '',
            //   cityId: '',
            //   countyId: '',
            //   detail: '',
            //   preferred: false
            // }
            // this.$refs[formValidate].resetFields()
            this.modal1 = true
          }
        }
      }
    },
    changeProvinces(value) {
      console.log(value,'省改变获取市数据');
      this.citiesArr = this.addressList[value]
      this.formValidate.provinceId = value
    },
    changeCitys(value) {
      console.log(value,'市改变获取区数据');
      this.countyArr = this.addressList[value]
      this.formValidate.cityId = value
    },
    // 省
    changeProvince(value) {
      console.log(value,'省变化事件');
      this.formValidate.cityId = ''
      this.formValidate.countyId = ''
      this.citiesArr = this.addressList[value]
      this.formValidate.provinceId = value
      console.log(this.formValidate,'生变化数据');
    },
    // 市
    changeCity(value) {
      console.log(value,'市变化事件');
      this.countyArr = this.addressList[value]
      this.formValidate.cityId = value
      console.log(this.formValidate,'市变化数据');
    },
    // 区
    changeArea(value) {
      console.log(value,'区域id');
      this.formValidate.countyId = value
      console.log(this.formValidate);
      console.log(this.formValidate,'区域变化数据');
    },
    // 保存
    async ok(name) {
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          this.modal_loading = true
          let data = JSON.parse(JSON.stringify(this.formValidate))
          data.preferred = Number(data.preferred)
          console.log(data);
          const res = await addressPost(data)
          console.log(res)
          if (res.status) {
            this.modal1 = false
            this.modal_loading = false
            this.getaddress()
          }
          this.modal_loading = false
        } else {
          // this.$Message.error('验证错误')
        }
      })
    },
    // 取消
    cancel() {
      this.modal1 = false
      this.modal2 = false
    },
    // 删
    del(id) {
      console.log(id)
      this.id = id
      this.modal2 = true
    },
    async btnOK() {
      this.modal_loading = true
      const res = await Deladdress({ id: this.id })
      console.log(res)
      if (res.status) {
        this.modal2 = false
        this.$Message.success('删除成功')
        this.modal_loading = false
        this.getaddress()
      }
    }
  },
  computed: {},
  watch: {}
}
</script>
<style lang='less' scoped>
  .w100{
    width:100px !important;
  }
  .mb10{
    margin-bottom:10px !important;
  }
  .pl10{
    padding-left:10px !important;
  }
  .pr10{
    padding-right:10px !important;
  }
  .borderB{
    border-bottom: 1px solid #e2e2e2;
  }
.addressList {
  width:100%;
  .topClass{
    width:98%;
    min-height: 60px;
    margin-bottom: 10px;
    background: #FFFFFF;
    -webkit-box-shadow: 2px 2px 30px #e2e2e2 !important;
    box-shadow: 2px 2px 30px #e2e2e2!important;
    opacity: 1;
    padding-left: 10px;
    padding-top: 10px;
    display:flex;
    align-items: center;
    h3{
      width: 64px;
      height: 16px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      line-height: 0px;
      color: #505050;
      opacity: 1;
    }
  }
  .main {
    width:98%;
    margin-top: 10px;
    height: 100%;
    min-height: 750px;
    background: #FFFFFF;
    -webkit-box-shadow: 2px 2px 30px #e2e2e2!important;
    box-shadow: 2px 2px 30px #e2e2e2!important;
    opacity: 1;
    padding-left: 10px;
    padding-top: 10px;
    /*margin-top: 34px;*/
    // margin: 48px 0 0 240px;
    .mian-add {
      display: inline-block;
      // width: 100px;
      font-size: 16px;
      color: #e90d0d;
      padding: 7px 34px;
      border: 1px solid #e90d0d;
      border-radius: 2px;
      cursor: pointer;
      margin-bottom: 10px;
    }
    .main-total {
      /*font-size: 16px;*/
      font-weight: 500;
      color: #434343;
      padding: 12px 0 12px 0px;
      /*padding: 12px 0 12px 20px;*/
      /*background-color: #f2f2f2;*/
      /*letter-spacing: 1px;*/
      /*margin-bottom: 35px;*/
      i {
        color: #e90d0d;
      }
    }
    .main-center {
      padding-left: 20px;
      .ivu-row {
        padding: 18px 0;
        .ivu-col {
          .h3 {
            font-size: 22px;
            font-weight: bold;
            color: #434343;
          }
          .h4 {
            font-size: 14px;
            color: #434343;
            line-height: 30px;
          }
          .default {
            color: #ffffff;
            font-weight: 500;
            font-size: 12px;
            padding: 5px 8px;
            background-color: #e90d0d;
            border-radius: 2px;
          }
          .span-btn {
            font-size: 16px;
            font-weight: 500;
            color: #0074ff;
            padding: 7px;
            border: 1px solid #0074ff;
            cursor: pointer;
            border-radius: 2px;
            text-align: right;
          }
        }
      }
      font-family: Source Han Sans CN;
      opacity: 1;
      .itemFlexClass{
        display: flex;
        padding-top: 44px;
        .itemLeftClass{
          flex:9;
          display: flex;
          flex-direction: column;
          .itemLeftTopClass{
            display:flex;
            flex-direction:row;
          }
          .h3 {
            font-size: 16px;
            font-weight: bold;
            color: #505050;
          }
          .h4 {
            font-size: 14px;
            color: #505050;
            line-height: 30px;
          }
          .defauldAddress{
            display: flex;
            justify-content:center;
            align-items:center;
            span{
              width:70px;
              /*text-align: center;*/
              /*color: #000c17;*/
              /*font-size: 12px;*/
              /*background-color: #e2e2e2;*/
              /*border-radius: 3px;*/
            }
            text-align: center;
            color: #505050;
            font-size: 14px;
            background-color: #E7E7E9;
            border-radius: 3px;
           }
        }
        .itemRightClass{
          flex:1;
          display:flex;
          .span-btn {
            width: 28px;
            font-size: 14px;
            color: #377CF1;
            margin: 7px;
            cursor: pointer;
            text-align: right;
          }
        }
      }
    }
  }
  /deep/.ivu-modal-footer {
    border-top: 0;
  }
}
</style>